import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

export default function NativeStatusBar() {
  if (Capacitor.isNativePlatform()) {
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setStyle({
      style: Style.Dark,
    });
    /**
     * This will put the webview over the status bar wherever its supported. In conjunction with things like
     * pt-[env(safe-area-inset-top)], this lets us get easy bg color support in the status bar in (at least) iOS.
     */
    StatusBar.setOverlaysWebView({ overlay: true });
  }

  return null;
}
